import { render } from "./InteractiveMenuSectionView.vue?vue&type=template&id=8bf7d7f0&scoped=true"
import script from "./InteractiveMenuSectionView.vue?vue&type=script&lang=js"
export * from "./InteractiveMenuSectionView.vue?vue&type=script&lang=js"

import "./InteractiveMenuSectionView.vue?vue&type=style&index=0&id=8bf7d7f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf7d7f0"]])

export default __exports__